import { AppContent } from "./AppContent";
import { AppStoreProvider } from "./store/AppStoreProvider";
import { TealiumHandler } from "./TealiumHandler";
import { AlertMessageProvider } from "./contexts/AlertMessaging/context";
import { useDesignSystemOverrides } from "../helpers/useDesignSystemOverrides";

const AppInner = () => {
  useDesignSystemOverrides();

  return <AppContent />;
};

export const App = () => (
  <AppStoreProvider>
    <TealiumHandler>
      <AlertMessageProvider>
        <AppInner />
      </AlertMessageProvider>
    </TealiumHandler>
  </AppStoreProvider>
);
